import { NgModule } from '@angular/core';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { LoaderComponent } from './components/loader/loader.component';
import {DatePipe, NgClass, NgForOf, NgIf, NgStyle} from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { ButtonComponent } from '../../ui/button/button.component';
import { TextCollapseComponent } from '../../ui/text-collapse/text-collapse.component';
import { CountdownTimerComponent } from '../../ui/countdown-timer/countdown-timer.component';
import { InputPhoneComponent } from '../../ui/input-phone/input-phone.component';
import { InputComponent } from '../../ui/input/input.component';
import { IconComponent } from '../../ui/icon/icon.component';
import { UiIconComponent } from '../../ui/ui-icon/ui-icon.component';
import { AuthSocialComponent } from '../../ui/auth-social/auth-social.component';
import { ButtonToggleComponent } from '../../ui/button-toggle/button-toggle.component';
import { LoaderProgressBarComponent } from './components/loader-progress-bar/loader-progress-bar.component';
import { MatProgressBar } from '@angular/material/progress-bar';
import { DropdownComponent } from '../../ui/dropdown/dropdown.component';
import { CheckboxComponent } from '../../ui/checkbox/checkbox.component';
import { InputCityComponent } from '../../ui/input-city/input-city.component';
import { SimplebarAngularModule } from 'simplebar-angular';
import { ArrowButtonComponent } from '../../ui/arrow-button/arrow-button.component';
import { ModalSingleComponent } from '../../ui/modal/modal-single/modal-single.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    BreadcrumbsComponent,
    LoaderComponent,
    ButtonComponent,
    TextCollapseComponent,
    CountdownTimerComponent,
    InputPhoneComponent,
    IconComponent,
    AuthSocialComponent,
    ButtonToggleComponent,
    LoaderProgressBarComponent,
    DropdownComponent,
    CheckboxComponent,
    InputCityComponent,
    ArrowButtonComponent,
    ModalSingleComponent,
  ],
  imports: [
    NgForOf,
    NgIf,
    NgStyle,
    RouterLink,
    MatDialogModule,
    InputComponent,
    UiIconComponent,
    DatePipe,
    MatProgressBar,
    NgClass,
    SimplebarAngularModule,
    ReactiveFormsModule,
  ],
  exports: [
    LoaderComponent,
    BreadcrumbsComponent,
    ButtonComponent,
    CountdownTimerComponent,
    InputPhoneComponent,
    TextCollapseComponent,
    IconComponent,
    UiIconComponent,
    AuthSocialComponent,
    ButtonToggleComponent,
    LoaderProgressBarComponent,
    DropdownComponent,
    CheckboxComponent,
    InputCityComponent,
    ArrowButtonComponent,
    ModalSingleComponent
  ],
})
export class SharedModule { }
